import { useQuery } from "@tanstack/react-query";
import { getTestimonialSection } from "../../api/apiTestimonialSection";

export const useGetTestimonialSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["testimonial-section"],
        queryFn: getTestimonialSection,
    });

    return {
        testimonialSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
